<template>
  <div class="tablaListado">
    <a-table
      :columns="columnsTable"
      :data-source="imports"
      row-key="id"
      size="middle"
      :pagination="false"
      :scroll="scrollStyle"
      :row-class-name="getRowClass"
    >
      <template #titleEntity v-if="!isTypeBusiness">
        <span> Empresas </span>
      </template>

      <template #entity="{ record }">
        <div class="name" v-if="!isTypeBusiness">
          <span>{{ record.entity.name }}</span>
        </div>
      </template>
      <template #titleBases v-if="showBases">
        <span> Base </span>
      </template>
      <template #base="{ record }">
        <div class="name" v-if="showBases">
          <span>{{ record.base?.name }}</span>
        </div>
      </template>
      <template #progress="{ text }">
        <span>
          <a-tag>
            {{ getProgress(text) }}
          </a-tag>
        </span>
      </template>
      <template #status="{ text }">
        <span>
          <a-tag :color="getStatusColor(text)">
            {{ getStatusName(text) }}
          </a-tag>
        </span>
      </template>
      <template #type_import="{ text }">
        <div v-if="text">
          <span>{{ getChangeName(text) }}</span>
        </div>
      </template>

      <template #info="{ record }">
        <a-button
          v-if="record.status_name === ImportStatus.Error"
          class="button"
          type="link"
          @click="handleDownloadErrors(record)"
        >
          Descargar errores
        </a-button>
        <span> </span>
      </template>
    </a-table>
    <import-errors-modal
      :data="record.errors"
      :errorsLength="getErrorsLength(record)"
      v-if="record"
      @onCloseModal="handleCloseModalWithRecord"
    />
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";

import { ImportStatus } from "@/app/imports/utils/enums";
import { ImportStatusName, importsTableColumns } from "@/app/imports/utils/constants";
import { downloadFile } from "@/app/shared/utils/file";
import { downloadErrors } from "@/app/imports/services/requests/imports/downloadErrors";

import ImportErrorsModal from "@/app/imports/components/modals/imports/ImportErrorsModal.vue";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";

export default defineComponent({
  components: {
    ImportErrorsModal,
  },
  setup() {
    const store = useStore();
    const isTypeBusiness = computed(() => user.value?.customer?.type_business == 2);
    const user = computed(() => store.getters["getDataUser"]);
    const showBases = computed(() => user.value?.customer?.enable_bases);

    const { scrollStyle } = useScrollResize({ headerMargin: 180 });

    return {
      isTypeBusiness,
      user,
      showBases,
      ImportStatus,
      scrollStyle,
    };
  },
  data() {
    return {
      columns: importsTableColumns(this.showBases),
      record: null,
      errorsCount: 0,
    };
  },
  computed: {
    imports() {
      return this.$store.getters["getFilteredImports"];
    },
    columnsTable() {
      // const column = columnsFixedTableLeft(this.columns);
      // return column;
      return this.columns;
    },
    // changeText() {
    //   return;
    // },
  },

  methods: {
    async handleDownloadErrors(record) {
      const data = await downloadErrors(record.id);

      downloadFile(data, `errors-${record.id}`, { useResponseFileName: true });
    },
    getErrorsLength(record) {
      if (!record) {
        return 0;
      }

      const exceptions = record?.errors?.exceptions?.length || 0;
      const unknowns = record?.errors?.unknowns?.length || 0;
      const forgottens = record?.errors?.forgottens?.length || 0;
      const invalids = record?.errors?.invalids?.length || 0;

      return exceptions + unknowns + forgottens + invalids;
    },
    getErrorsInfo(record) {
      const errorsCount = this.getErrorsLength(record);

      if (errorsCount === 0) return "";
      if (errorsCount === 1) return "1 error";
      return `${errorsCount} errores`;
    },
    handleCloseModalWithRecord() {
      this.record = null;
    },
    handleShowModalWithRecord(event, record) {
      this.record = record;
    },
    getRowClass(item) {
      return item.status_name == ImportStatus.Error ? "imports-row--error" : "";
    },
    getStatusName(status) {
      return ImportStatusName[status];
    },
    getStatusColor(status) {
      if (status === ImportStatus.Success) return "green";
      if (status === ImportStatus.Error) return "red";
      return "blue";
    },
    getProgress(status) {
      if (status === ImportStatus.Waiting) return "Procesando...";
      return "Completado";
    },
    getChangeName(type_import) {
      if (type_import === "Cuentas") {
        return "Productos";
      } else if (type_import === "Clientes") {
        return "Contactos";
      } else if (type_import === "Telefonos") {
        return "Teléfonos";
      } else if (type_import === "Contactos") {
        return "Referidos";
      }
      return type_import;
    },
  },
});
</script>

<style lang="sass" scoped>
.button
  padding: 0
  height: 22px

:deep(.imports-row--error)
  background-color: $red-1
  transition: none

:deep(.imports-row--error .ant-table-cell-fix-left)
  background-color: $red-1
</style>
